<template>
  <div>
    <Headersys />
    <div class="content">
      <div style="width: 80%;margin: auto;">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码">
                <el-input v-model="form.uniscid"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业名称">
                <el-input v-model="form.entname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="注册资本">
                <el-input v-model="form.regcap"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类型">
                <el-input v-model="form.enttypeCn"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="成立日期">
                <el-input v-model="form.estdate"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法定代表人">
                <el-input v-model="form.lerep"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="住所">
                <el-input v-model="form.dom" type="textarea"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经营范围">
                <el-input v-model="form.opscope" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="年">
                <el-input v-model="form.Y"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="月">
                <el-input v-model="form.M"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="日">
                <el-input v-model="form.D"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="正本字号">
                <el-input v-model="form.zbSize"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="副本字号">
                <el-input v-model="form.fbSize"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <back print='2' @toPrintEve="startPrint" />
  </div>
</template>
<script>
import lodop from "@/assets/js/lodop"
import applyList from "../../../public/static/kwysList";

export default {
  name: '',
  data() {
    return {
      //
      // form: {
      //   uniscid: '91370705MA7E7WGXXN',
      //   entname: '山东卓宏信息科技有限公司',
      //   regcap: '叁佰万元',
      //   enttypeCn: '有限责任公司（自然人独资）',
      //   estdate: '2021 年 11 月 30 日',
      //   lerep: '孙瑞雪',
      //   opscope: '一般项目：信息系统集成服务；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；云计算装备技术服务；大数据服务；人工智能应用软件开发；软件开发；网络与信息安全软件开发；软件销售；物联网应用服务；工业互联网数据服务；计算机软硬件及辅助设备零售；数据处理和存储支持服务；网络设备销售；信息安全设备销售；科技中介服务；人工智能基础资源与技术平台；智能无人飞行器销售；安防设备销售；安全系统监控服务；安全技术防范系统设计施工服务；消防器材销售；电气设备销售；电力电子元器件销售；电子产品销售；云计算设备销售；计算机软硬件及辅助设备批发；计算机及办公设备维修；广告设计、代理；互联网安全服务；互联网数据服务；制冷、空调设备销售；生态环境监测及检测仪器仪表销售；办公用品销售；五金产品批发；五金产品零售；会议及展览服务；企业管理；信息咨询服务（不含许可类信息咨询服务）；劳务服务（不含劳务派遣）。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：互联网信息服务；计算机信息系统安全专用产品销售；电气安装服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）',
      //   dom: '山东省潍坊市奎文区胜利东街4778号4号楼1-1234',
      //   Y: '2021',
      //   M: '11',
      //   D: '30'
      // }
      form: {
        uniscid: '91370705MA7EKR9F5D',
        entname: '潍坊灿坤新能源有限公司',
        regcap: '叁佰叁拾玖万元整',
        enttypeCn: '有限责任公司（非自然人投资或控股的法人独资）',
        estdate: '2021 年 12 月 07 日',
        lerep: '刘梅梅',
        opscope: '一般项目：新兴能源技术研发；住宅水电安装维护服务；厨具卫具及日用杂品批发；五金产品批发；建筑防水卷材产品销售；五金产品零售；人造板销售；建筑装饰材料销售；家用电器安装服务；电动汽车充电基础设施运营；充电桩销售；软件开发；集中式快速充电站；智能输配电及控制设备销售；新能源汽车换电设施销售；新能源汽车电附件销售；新能源汽车整车销售；新能源汽车生产测试设备销售；配电开关控制设备销售；光伏设备及元器件销售；光伏发电设备租赁；充电控制设备租赁；机械设备租赁；仓储设备租赁服务；电池销售；电池零配件销售；机动车充电销售；电子元器件零售；电力电子元器件销售；电子元器件批发；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；环境保护专用设备销售；停车场服务；信息系统集成服务；人工智能行业应用系统集成服务；物联网技术服务；广告制作；广告发布；广告设计、代理；网络与信息安全软件开发；网络技术服务；信息技术咨询服务；礼仪服务；会议及展览服务；数字创意产品展览展示服务；网络设备销售；计算机软硬件及辅助设备零售；计算机软硬件及辅助设备批发；软件销售；物联网设备销售；专业设计服务；工程管理服务；招投标代理服务；数字文化创意内容应用服务；数字文化创意软件开发；平面设计；办公服务；建筑材料销售；汽车装饰用品销售；金属门窗工程施工；门窗销售；家具安装和维修服务；室内木门窗安装服务；家用电器零配件销售；市场营销策划；普通机械设备安装服务；电子、机械设备维护（不含特种设备）；专用设备修理；交通及公共管理用标牌销售；可穿戴智能设备销售；智能车载设备销售；照明器具销售；轻质建筑材料销售；文具用品零售；体育用品及器材零售；办公用品销售；文具用品批发；日用品批发；日用品销售；互联网销售（除销售需要许可的商品）；图文设计制作；打字复印。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：电气安装服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）',
        dom: '山东省潍坊市奎文区东风东街8580号1号楼1-2306',
        Y: '2021',
        M: '12',
        D: '07',
        zbSize: '14',
        fbSize: '10',
      }
    };
  },
  created() {
    //
  },
  mounted() {
    //
    // console.log(applyList['证照打印']);
    var list = applyList['证照打印']
    var arr = []
    list.forEach(el => {
      if (el.lwCode) {
        arr.push({
          title: el.title,
          code: el.lwCode
        })
      }
    })
    console.log(arr);

  },
  methods: {
    //
    startPrint() {
      var data = this.form
      if (data.opscope.length > 700) {
        this.$alert('您的营业执照经营范围内容过长暂不支持终端打印,请到奎文区政务服中心窗口打印', '提示', {
          confirmButtonText: '确定',
          lockScroll: false
        });
        return
      }
      this.$rqt.print_getEntCode(data.uniscid, data.entname).then(res => {
        console.log(res);
        var info = JSON.parse(res.msg)
        if (info.message_content.qrimage) {
          var codeUrl = "data:image/jpg;base64," + info.message_content.qrimage
          lodop.YYZZZB1(data, codeUrl)
          lodop.YYZZFB1(data, codeUrl)
        } else {
          this.$alert(data.message_header.errorInfo, '提示', {
            confirmButtonText: '确定',
            lockScroll: false
          });
        }
      })
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  position: relative;
}
</style>